import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router";
import styles from "./login.module.css"
import { useEffect } from "react";
import { jwtDecode } from "jwt-decode";

export default function Login() {
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            return;
        }

        const decoded = jwtDecode(token);

        if (decoded.exp! < Date.now() / 1000) {
            return;
        }

        const initialUrl = localStorage.getItem("initialUrl") ?? "/";
        localStorage.removeItem("initialUrl");
        navigate(initialUrl, { replace: true });
    }, [navigate]);

    return (
        <div className={styles.container}>
            <GoogleLogin
                onSuccess={(resp) => {
                    localStorage.setItem("token", resp.credential!);
                    const initialUrl = localStorage.getItem("initialUrl") ?? "/";
                    localStorage.removeItem("initialUrl");
                    navigate(initialUrl, { replace: true });
                }}
                onError={() => console.error("Login failed!")} />
        </div>)
}